// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__XedKw","background":"classes_background__3s6m8","container":"classes_container__1ptvV","header":"classes_header__2PirG","cross":"classes_cross__3dMql"};